import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import ProductSelectionForm from "./indexForm";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { ReducerUtils } from "../../../constants/reducers";
import { useHistory } from "react-router";
import { useStyles } from "../indexFormStyles";
import {
  buildLeadPageUrl,
  convertToAge,
  downloadFile,
  getRoute,
  getStorageItem,
  setStorageItem,
} from "../../../helpers/utils";
import {
  SLUG_PARTNER_SUREPASS,
  SLUG_YEARLY,
  SLUG_TAB_SAVINGS,
  SLUG_TAB_TERM,
  SLUG_EDUCATION_10TH,
  SLUG_CALCULATOR_CONFIG,
  SLUG_TERM_PRODUCT,
  SLUG_TROP_PRODUCT,
} from "../../../constants";
import { postWebService } from "../../../helpers/server";
import {
  initialFormState,
  mapping,
  riders,
} from "../../../defaultValues/product";
import { validations } from "../../../messages/validation";
import {
  buildBenefitIllustrationPayload,
  buildPremiumPayload,
  buildProductCategoriesPayload,
  buildProductDetailsPayload,
  buildProductList,
  buildSavingGridPayload,
  buildShareDocumentsPayload,
  buildShareProductDocumentsPayload,
  buildWrapperTokenHeader,
  buildUpdateCustomerPayload,
  buildUpdateQuotationPayload,
  buildFetchAppConfigPayload,
  getDefaultProductId,
  isValidPolicyTermOptions,
  isValidLifeCoverOptions,
  maximumPolicyTenure,
  rebuildCalculatePremiumResponse,
  rebuildCorpusOptions,
  rebuildPolicyTermOptions,
  traverseProductDetailsResponse,
  traverseSavingGridResponse,
  extractPolicyTermFromMapper,
} from "../../../helpers/product";
import {
  getMinDobDate,
  getMaxDobDate,
  isValidDob,
  isValidAnnualIncome,
} from "../../../helpers/buyflow";
// import { useDeepCompareEffect } from "../../../hooks/useDeepCompareEffect";

function ProductSelection({ classes: { loaderBox } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [backdrop, setBackdrop] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    sumAssured: false,
    premium: false,
    annualIncome: false,
  });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...initialFormState });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({
    review: false,
    snackbar: false,
  });
  const [quotation, setQuotation] = useState({});
  const [touchFields, setTouchFields] = useState({
    dob: false,
    annualIncome: false,
  });
  const [premiumOptions, setPremiumOptions] = useState([]);
  const [corpusOptions, setCorpusOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const [categories, setCategories] = useState([]);
  const [minAnnualIcome, setMinAnnualIncome] = useState(100000);
  const [maxADBSumAssured, setMaxADBSumAssured] = useState(3000000);
  const [productList, setProductList] = useState([]);
  const [selectedProductTab, setSelectedProductTab] = useState(null);
  const [isLifeCoverageValid, setIsLifeCoverageValid] = useState(true);
  const [isInputValid, setIsInputValid] = useState(false);

  /* Start: Calculator Config Section */
  const [calculatorConfig, setCalculatorConfig] = useState(null);
  const [calculatorPopup, setCalculatorPopup] = useState(false);
  const [iframeSrc, setIframeSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [section, setSection] = useState({ calculator: true, bi: false });
  const [useCalculator, setUseCalculator] = useState({
    SAVINGS: false,
    TERM: false,
    HEALTH: false,
  });
  /* End: Calculator Config Section */

  useEffect(() => {
    window.proceedToBI = proceedToBI;
    return () => {
      delete window.proceedToBI;
    };
  }, []);

  useEffect(() => {
    async function wrapperToken() {
      try {
        const response = await postWebService(
          "token.php",
          {},
          buildWrapperTokenHeader()
        );

        setStorageItem("access-token", response.data.access_token);

        await fetchApplicationConfiguration(SLUG_CALCULATOR_CONFIG);
        await productCategories();
        setTimeout(() => setIsLoaded(true), 1000);
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);

  async function fetchDetails() {
    setQuotation({});
    setForm({
      ...initialFormState,
      age: "",
      dob: "",
      type: selectedTab == 1 ? SLUG_TAB_TERM : SLUG_TAB_SAVINGS,
    });
    setStorageItem("productCategory", selectedTab == 1 ? 1 : 2);

    await dispatchEvent(ReducerUtils.product.details, null);
    await fetchSavingGrid();
    await fetchProductDetails();
  }

  async function productCategories() {
    try {
      const response = await postWebService(
        "products-category.php",
        buildProductCategoriesPayload()
      );

      let activeTab = 0;
      response.data.map((item) => {
        item.disabled =
          getStorageItem("partnerId") == 4 && item.name == SLUG_TAB_SAVINGS;

        if (item.is_default) {
          activeTab = item.name === SLUG_TAB_TERM ? 1 : 0;
        }
      });

      setSelectedTab(activeTab);
      setCategories(response?.data ?? []);
    } catch (error) {
      // console.log(error);
    }
  }

  async function fetchSavingGrid() {
    try {
      const response = await postWebService(
        "saving-grid.php",
        buildSavingGridPayload()
      );

      setForm({
        ...form,
        ...traverseSavingGridResponse(response.data),
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async function fetchProductDetails() {
    try {
      const response = await postWebService(
        "products.php",
        buildProductDetailsPayload()
      );

      dispatchEvent(ReducerUtils.product.details, response.data);
    } catch (error) {
      // console.log(error);
    }
  }

  useEffect(() => {
    async function calulatePremium() {
      try {
        let flag = true;
        if (selectedProduct?.category === SLUG_TAB_TERM) {
          const comparableSumAssured =
            selectedProduct?.productConfig?.comparable_sum_assured ?? 250000;
          const minIncome =
            form.corpus > comparableSumAssured
              ? selectedProduct?.productConfig?.min_annual_income
              : 100000;

          validateAnnualIncome("annualIncome", minIncome);
          setMinAnnualIncome(minIncome);
          flag = form.annualIncome < minIncome ? false : true;
        }

        setIsInputValid(flag);

        if (
          selectedProduct?.category === SLUG_TAB_TERM &&
          form.education === SLUG_EDUCATION_10TH &&
          form.corpus >= maxADBSumAssured
        ) {
          setForm({
            ...form,
            corpus: 2500000,
          });
          flag = false;
        }

        if (selectedProduct?.category === SLUG_TAB_TERM) {
          const validPolicyTerm = isValidPolicyTermOptions(
            form,
            selectedProduct?.productConfig
          );
          const validCorpus = isValidLifeCoverOptions(
            form,
            selectedProduct?.productConfig
          );
          if (!validPolicyTerm || !validCorpus) {
            flag = false;
          }
        }

        if (!flag) {
          setQuotation({});
          return;
        }

        setBackdrop(true);
        const response = await postWebService(
          "premium.php",
          buildPremiumPayload({
            ...form,
            pt: extractPolicyTermFromMapper(selectedProduct, form),
            age: convertToAge(form.dob),
          })
        );

        const premiumResponse = rebuildCalculatePremiumResponse(
          response.data,
          form?.productConfig,
          selectedProduct
        );

        setForm({
          ...form,
          ...(form?.productConfig
            ? {
                pt: extractPolicyTermFromMapper(selectedProduct, form),
              }
            : {}),
        });

        setQuotation({
          ...premiumResponse,
        });

        setBackdrop(false);
      } catch (error) {
        console.log(error);
      }
    }

    if (selectedProduct?.category === SLUG_TAB_TERM) {
      setIsInputValid(false);
    }

    form.dob &&
      form.gender &&
      (form.premium || form.corpus) &&
      isValidDob(form.dob, form.type) &&
      isValidAnnualIncome(form.annualIncome, form?.productConfig) &&
      state?.productDetails?.length &&
      ((selectedProduct?.category === SLUG_TAB_TERM && form.education) ||
        selectedProduct?.category !== SLUG_TAB_TERM) &&
      calulatePremium();
  }, [
    form.dob,
    form.education,
    form.gender,
    form.paymentFrequency,
    form.premium,
    form.multiplier,
    form.ppt,
    form.corpus,
    form.occupation,
    form.annualIncome,
    form.pt,
    form.riders.ADBR,
    form.riders.CCR,
    form.riders.CI,
    form.riders.CHB,
    form.riders.DDR,
    form.riders.HGR,
    form.riders.TPR,
    form.riders.CER,
  ]);

  useEffect(() => {
    form.dob &&
      isValidDob(form.dob, form.type) &&
      setFormState("age", convertToAge(form.dob));
  }, [form.dob]);

  useEffect(() => {
    if (
      selectedProduct?.category === SLUG_TAB_TERM &&
      form.education === SLUG_EDUCATION_10TH &&
      form.corpus >= maxADBSumAssured
    ) {
      setQuotation({});
    }
  }, [form.education]);

  useEffect(() => {
    selectedTab !== null && fetchDetails();
    selectedTab !== null &&
      calculatorConfig &&
      syncCalculatorConfiguration(selectedTab);
  }, [selectedTab]);

  useEffect(() => {
    if (form.age) {
      setFormState(
        "policyTermOptions",
        rebuildPolicyTermOptions(
          selectedProduct?.productConfig ?? null,
          form.age
        )
      );
    }
  }, [form.age]);

  useEffect(() => {
    form?.policyTermOptions?.length > 0 &&
      setFormState("ppt", form.policyTermOptions[0].value);
  }, [form.policyTermOptions]);

  useEffect(() => {}, [productList]);

  useEffect(() => {
    if (state?.productDetails?.length) {
      const list = buildProductList(state?.productDetails);

      setProductList(list);
      setSelectedProductTab(getDefaultProductId(list));

      handleProductSelection();
    }
  }, [state.productDetails]);

  useEffect(() => validateDateOfBirth("dob"), [form.dob]);

  useEffect(
    () => validateAnnualIncome("annualIncome", minAnnualIcome),
    [form.annualIncome]
  );

  useEffect(() => {
    setFormState(
      "multipierFactor",
      form.paymentFrequency === SLUG_YEARLY ? 12 : 1
    );
  }, [form.paymentFrequency]);

  useEffect(() => {}, [quotation]);

  useEffect(() => {
    const policyTermOptions = rebuildPolicyTermOptions(
      selectedProduct?.productConfig ?? null,
      convertToAge(form.dob)
    );

    if (policyTermOptions.length) {
      const isValid =
        Number(form.ppt) >= 10 &&
        Number(form.ppt) <=
          maximumPolicyTenure(
            form.dob,
            selectedProduct?.productConfig?.max_coverage_age
          ) &&
        Number(form.ppt) % 1 === 0;

      if (!isValid) {
        setQuotation({});
      }

      setErrorMessage({
        ...errorMessage,
        ppt: !isValid,
      });
    }
  }, [form.ppt]);

  useEffect(() => {
    const corpusOptions = rebuildCorpusOptions(form);

    if (corpusOptions.length) {
      const isValid =
        form.corpus >= 500000 &&
        form.corpus <= corpusOptions[corpusOptions?.length - 1]?.value &&
        (form.corpus % 50000 === 0 || form.corpus % 100000 === 0);

      if (!isValid) {
        setQuotation({});
      }

      setErrorMessage({
        ...errorMessage,
        corpus: !isValid,
      });
    }
  }, [form.corpus]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const cbSuccessEkycConfig = ({ EKYC_CURRENT_PARTNER }) => {
    setForm({ ...form, ekycPartner: EKYC_CURRENT_PARTNER });
    setStorageItem("ekycPartner", EKYC_CURRENT_PARTNER);

    updateProductQuotation();
  };

  const cbSuccessCalculatorConfig = async ({ CALCULATOR_CONFIG = null }) => {
    const config = CALCULATOR_CONFIG ? JSON.parse(CALCULATOR_CONFIG) : null;

    setCalculatorConfig(config);
  };

  const fetchApplicationConfiguration = async (keyname = "") => {
    try {
      const response = await postWebService(
        "app_config.php",
        buildFetchAppConfigPayload()
      );

      keyname === SLUG_CALCULATOR_CONFIG
        ? cbSuccessCalculatorConfig(response.data)
        : cbSuccessEkycConfig(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const handleBack = () => handleClose();

  const handleProductSelection = (productId = null) => {
    const object = traverseProductDetailsResponse(
      state?.productDetails,
      productId
    );

    if (object.category === SLUG_TAB_TERM) {
      mapping.maxAgeLimit[SLUG_TAB_TERM] =
        object.productSlug === SLUG_TROP_PRODUCT ? 51 : 46;
    }

    setSelectedProduct({
      ...object,
    });

    setForm({
      ...form,
      dob: "",
      age: "",
      ...object,
      ...(object?.productConfig
        ? {
            pt: extractPolicyTermFromMapper(object, form),
          }
        : {}),
      ...(object?.category === SLUG_TAB_TERM && {
        education: object?.productConfig?.default_education,
      }),
    });

    setPremiumOptions(object.premiumOptions);
    setCorpusOptions(object.corpusOptions);
    setMinAnnualIncome(100000);
    setMaxADBSumAssured(3000000);
    setIframeSrc(object?.productConfig?.iframe_src ?? null);

    setStorageItem("productName", object.productName);
    setStorageItem("productSlug", object.productSlug);
    setStorageItem("pid", object.pid);
  };

  const generateBI = async (download = 0) => {
    try {
      setIsFormSubmitted(true);
      setBackdrop(true);
      const response = await postWebService(
        "benefitIllustration.php",
        buildBenefitIllustrationPayload(
          {
            ...form,
            download,
            pid: selectedProduct.pid,
            pt: extractPolicyTermFromMapper(selectedProduct, form),
          },
          quotation
        )
      );

      const { data } = response;
      const str = data.data.slice(9, -8);
      const result = JSON.parse(atob(str));

      if (result.code === 200) {
        setBackdrop(false);
        setIsFormSubmitted(false);
        toggleModal("snackbar", true);

        if (result?.url) {
          result?.url && downloadFile(result?.url, "Benefit-Illustration.pdf");
        }
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const handleDownload = () => {
    setFormState("download", 1);
    generateBI(1);
  };

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleChangeCheckbox = (e, name) =>
    setForm((prev) => ({
      ...prev,
      riders: {
        ...prev.riders,
        [name]: e.target.checked,
      },
    }));

  const handleChangeChipSelect = (name, value) => {
    setFormState(name, value);
  };

  const handleClose = (keyname = "review", flag = false) =>
    toggleModal(keyname, false);

  const handleTabChange = (event, newValue) => setSelectedTab(newValue);

  const handleProductTabChange = (event, newValue) => {
    setQuotation({});
    setSelectedProductTab(newValue);
    handleProductSelection(newValue);
  };

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setBackdrop(false);

    setErrors(new Array(error));
  };

  const cbSuccessHandler = (response) => {
    const ekycPartner = getStorageItem("ekycPartner");
    setStorageItem("dob", form.dob);
    setStorageItem("gender", form.gender);
    setIsFormSubmitted(false);
    setBackdrop(false);
    navigateTo(
      getRoute(ekycPartner === SLUG_PARTNER_SUREPASS ? "ekycPartner" : "ekyc")
    );
  };

  const shareKnowledgeHubDocuments = async () => {
    try {
      const response = await postWebService(
        "emailwithattachment.php",
        buildShareDocumentsPayload({
          ...form,
          pid: selectedProduct.pid,
          mobile: getStorageItem("mobile"),
          productSlug: getStorageItem("userType"),
        })
      );

      cbSuccessHandler(response);
    } catch (error) {
      cbError(error);
    }
  };

  const errorHandler = () => (window.location.href = buildLeadPageUrl());

  const cbSuccessUpdateQuotation = ({ code }) =>
    code === 201 ? shareKnowledgeHubDocuments() : errorHandler();

  const updateProductQuotation = async () => {
    try {
      const response = await postWebService(
        "update-quote.php",
        buildUpdateQuotationPayload(
          {
            ...form,
            pid: selectedProduct.pid,
            pt: extractPolicyTermFromMapper(selectedProduct, form),
            partner_branch_code: getStorageItem("partnerBranchCode") || "",
          },
          quotation,
          maxADBSumAssured
        )
      );

      cbSuccessUpdateQuotation(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const updateCustomerDetails = async () => {
    try {
      setIsFormSubmitted(true);
      setBackdrop(true);
      const response = await postWebService(
        "update-customer.php",
        buildUpdateCustomerPayload({ ...form, pid: selectedProduct.pid })
      );

      if (response.data.code === 200) {
        fetchApplicationConfiguration();
      }
    } catch (error) {
      cbError(error);
    }
  };

  const handleProceed = async () => {
    setIsFormSubmitted(true);
    setBackdrop(true);

    updateCustomerDetails();
  };

  const handleShare = () => {
    setFormState("download", 0);
    generateBI(0);
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const onBackClickHandler = () => history.goBack();

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const toggleModal = (keyname = "review", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const validateDateOfBirth = (fieldName) => {
    if (form[fieldName]) {
      const minDate = getMinDobDate(mapping.maxAgeLimit[form.type]);
      const maxDate = getMaxDobDate();

      if (isValidDob(form[fieldName], form.type)) {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      } else if (!moment(form[fieldName]).isSameOrAfter(minDate)) {
        setErrorMessageState(
          fieldName,
          `${validations[fieldName].max} ${Number(
            mapping.maxAgeLimit[form.type] - 1
          )} years`
        );
      } else if (!moment(form[fieldName]).isSameOrBefore(maxDate)) {
        setErrorMessageState(fieldName, validations[fieldName].min);
      } else {
        setErrorMessageState(fieldName, validations[fieldName].valid);
      }
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateAnnualIncome = (fieldName, minIncome = 100000) => {
    if (form[fieldName]) {
      if (
        selectedProduct?.productSlug === SLUG_TROP_PRODUCT ||
        selectedProduct?.productSlug === SLUG_TERM_PRODUCT
      ) {
        const comparableSumAssured =
          selectedProduct?.productConfig?.comparable_sum_assured ?? 2500000;
        minIncome =
          form.corpus > comparableSumAssured
            ? selectedProduct?.productConfig?.min_annual_income
            : 100000;
      }

      setMinAnnualIncome(minIncome);
      const isValid = isValidAnnualIncome(
        form.annualIncome,
        form?.productConfig,
        minIncome
      );

      if (isValid) {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      } else {
        setErrorMessageState(
          fieldName,
          `${validations[fieldName].valid} ${
            minIncome ? minIncome : minAnnualIcome
          }.`
        );
      }
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const downloadFactsheet = () => {
    const partnerSlug = getStorageItem("partner") ?? "bom";
    const productSlug = getStorageItem("productSlug") ?? "parivar-vikas";
    downloadFile(
      `${
        process.env.REACT_APP_API_EP
      }public/savings/${partnerSlug}/${productSlug}/${
        mapping.languageFactsheet[form.language]
      }`,
      "Factsheet.pdf"
    );
  };

  const shareProductDocuments = async () => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService(
        "productdocuments.php",
        buildShareProductDocumentsPayload({
          ...form,
          pid: selectedProduct.pid,
          mobile: Number(getStorageItem("mobile")),
        })
      );

      setIsFormSubmitted(false);
    } catch (error) {
      cbError(error);
    }
  };

  const addClassToElement = () => {
    const el = document.getElementById("calculatorPopup");
    if (el) {
      el.classList.add("d-block");
    }
  };

  const openCalculator = () => {
    addClassToElement();
    setCalculatorPopup(true);
    toggleCalculatorBISection(false, true);
  };

  const toggleCalculatorPopUp = () => {
    const el = document.getElementById("calculatorPopup");
    if (el) {
      el.classList.remove("d-block");
    }

    setCalculatorPopup(false);
    setUseCalculator({
      SAVINGS: false,
      TERM: true,
      HEALTH: false,
    });
    toggleCalculatorBISection(false, true);
  };

  const proceedToBI = () => toggleCalculatorPopUp();

  const syncCalculatorConfiguration = (tabIndex = null) => {
    const tabname = tabIndex === 1 ? SLUG_TAB_TERM : SLUG_TAB_SAVINGS;

    if (tabname === SLUG_TAB_TERM) {
      addClassToElement();
    }

    const calculatorEnabled = calculatorConfig?.[tabname]?.enabled ?? false;

    toggleCalculatorBISection(calculatorEnabled, !calculatorEnabled);
  };

  const toggleCalculatorBISection = (calculator = false, bi = true) =>
    setSection({ calculator, bi });

  const onSubmit = (event) => {
    event.preventDefault();

    toggleModal();
    shareProductDocuments();
  };

  return isLoaded &&
    // state?.productDetails?.length > 0 &&
    (premiumOptions.length > 0 || corpusOptions.length > 0) &&
    selectedProduct &&
    selectedTab !== null &&
    calculatorConfig ? (
    <ProductSelectionForm
      backdrop={backdrop}
      calculatorConfig={calculatorConfig}
      calculatorPopup={calculatorPopup}
      categories={categories}
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleBack={handleBack}
      handleChange={handleChange}
      handleChangeCheckbox={handleChangeCheckbox}
      handleChangeChipSelect={handleChangeChipSelect}
      handleClose={handleClose}
      handleDownload={handleDownload}
      handleProceed={handleProceed}
      handleProductTabChange={handleProductTabChange}
      handleShare={handleShare}
      handleTabChange={handleTabChange}
      iframeSrc={iframeSrc}
      isFormSubmitted={isFormSubmitted}
      isInputValid={isInputValid}
      loading={loading}
      maxADBSumAssured={maxADBSumAssured}
      minAnnualIcome={minAnnualIcome}
      modal={modal}
      onBackClickHandler={onBackClickHandler}
      openCalculator={openCalculator}
      onSubmit={onSubmit}
      productList={productList}
      quotation={quotation}
      section={section}
      selectedProduct={selectedProduct}
      selectedProductTab={selectedProductTab}
      selectedTab={selectedTab}
      setLoading={setLoading}
      toggleCalculatorBISection={toggleCalculatorBISection}
      toggleModal={toggleModal}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProductSelection);
